import { LayoutProps, CompletionLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import { Content, BlockWrapper, Footer, CompletionProgress } from './CompletionLayout.styled'

export type CompletionLayoutSegments =
  | 'header'
  | 'content'
  | 'sectionTitle'
  | 'progress'
  | 'actions'
type InternalLayoutProps = LayoutProps<CompletionLayoutSegments>

export const CompletionSegment: React.FC<CompletionLayoutSegmentProps> = ({ children }) => (
  <>{children}</>
)

const CompletionLayout = ({ segments }: InternalLayoutProps) => {
  return (
    <Content>
      {segments?.header && <BlockWrapper>{segments.header}</BlockWrapper>}
      {segments?.content && <BlockWrapper>{segments.content}</BlockWrapper>}
      {segments?.sectionTitle && <BlockWrapper>{segments.sectionTitle}</BlockWrapper>}
      <Footer>
        {segments?.progress && <CompletionProgress>{segments.progress}</CompletionProgress>}
      </Footer>
    </Content>
  )
}

export default withLayout(CompletionLayout)
